function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.537 25.794c.066-1.04 1.552-1.132 2.397-1.741.892-.643 1.387-2.485 2.279-3.128.845-.61 3.127-1.043 3.127-1.043s.776-2.028 2.03-2.028c1.252 0 2.14 3.071 2.14 3.071 7.098 1.429 14.932-4.156 20.852-3.128C41.502 19.041 49.019 22.28 51 28.223c1.98 5.944-6.256 18.766-6.256 18.766s-8.34 1.043-7.298-1.042c.56-1.12 3.128-2.085 3.128-2.085-3.018-2.425-5.693-4.945-5.213-8.34-5.082 2.972-9.919 2.581-14.596 0L18.68 46.988s-8.34 1.043-7.298-1.042c.56-1.121 3.128-2.085 3.128-2.085l-1.043-11.468c-.21-2.314-11.243-1.643-10.93-6.6z"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 7.734,
  cy: 23.532,
  r: 0.521
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.521,
  cy: 25.375,
  r: 0.521
}), /*#__PURE__*/React.createElement("path", {
  d: "M51 28.223c.437.888 1.771 1.49 3.128 2.085h-2.71"
})), /*#__PURE__*/React.createElement("path", {
  d: "M32.234 37.085c.353 2.861 1.332 4.86 3.128 5.734 0 0-3.128 1.043-4.283 2.75-.826 1.222 6.368.795 6.368.795M22.851 36.564l-2.085 9.383H18.68M9 20c.334-1.025 1-3 2.4-1.7"
}));

var SvgBear = function SvgBear(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBear, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Bear.f716f0a8.svg";
export { ForwardRef as ReactComponent };